import React, { useEffect } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

function BarCode({ onScan }) {

  useEffect(() => {
    let barcode = "";
    let interval;

    const handleKeyDown = (evt) => {
      if (interval) clearTimeout(interval);

      if (evt.key === 'Enter') {
        if (barcode) {
          onScan(barcode);
          barcode = "";
        }
        return;
      }

      if (evt.key !== 'Shift' && evt.key.length === 1) {
        barcode += evt.key;
      }

      interval = setTimeout(() => barcode = "", 50);
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      if (interval) clearTimeout(interval);
    };
  }, [onScan]);

  return (
    <center>
      <BarcodeScannerComponent
        width={300}
        height={200}
        onUpdate={(err, result) => {
          if (result) {
            console.log(result)
            onScan(result.text);
          }
        }}
      />
    </center>
  );
}

export default BarCode;